import React, { useState } from 'react';
import { Product } from '../../models/interfaces';
import './productCard.css';

export const getProductImageUrl = (product: Product) =>
    product.image ? `${process.env.REACT_APP_IMAGES_URL}${product.image}` : '';

type Props = {
    product: Product;
    quantity: number;
    isSelected: boolean;
    onAdd: () => void;
    onRemove: () => void;
};

const ProductCard: React.FC<Props> = ({ product, quantity, onAdd, onRemove, isSelected }) => {
    const imageUrl = getProductImageUrl(product);
    // 'loading' muestra el placeholder animado; si la imagen ya está en caché (precargada) llega directo a 'loaded'
    const [imageState, setImageState] = useState<'loading' | 'loaded' | 'error'>('loading');

    return (
        <div
            className={`product-card ${isSelected ? 'selected' : ''}`}
            style={{
                width: 160,
                height: 270,
                margin: 15,
                padding: 8,
                borderRadius: 5,
                backgroundColor: isSelected ? 'rgba(0,0,0,0.05)' : 'white',
                boxShadow: '0 2px 3px rgba(0,0,0,0.1)',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between'
            }}>
            {/* Imagen */}
            <div style={{ width: '100%', height: '100px', overflow: 'hidden', borderRadius: 10 }}>
                {product.image && imageState !== 'error' ? (
                    <div className="product-card-image">
                        {imageState === 'loading' && <div className="product-card-skeleton" />}
                        <img
                            src={imageUrl}
                            alt={product.name}
                            decoding="async"
                            className={imageState === 'loaded' ? 'is-loaded' : ''}
                            onLoad={() => setImageState('loaded')}
                            onError={() => setImageState('error')}
                        />
                    </div>
                ) : (
                    <div className="product-card-no-image">
                        <i className="bi bi-image" />
                    </div>
                )}
            </div>

            {/* Nombre */}
            <strong style={{
                fontSize: 14,
                marginTop: 5,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                height: '3em' // para 2 líneas
            }}>
                {product.name}
            </strong>

            {/* Descripción */}
            <p style={{
                fontSize: 12,
                color: '#666',
                margin: '5px 0',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                height: '2.7em' // para 2 líneas
            }}>
                {product.shortDescription}
            </p>

            {/* Precio y botones */}
            <div>
                <p style={{ margin: 0 }}><strong>₡ {product.price.toLocaleString()}</strong></p>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 5 }}>
                    {quantity > 0 ? (
                        <>
                            <button className='btn btn-danger btn-sm' style={{ width: '30px' }} onClick={onRemove}>-</button>
                            <span>{quantity}</span>
                        </>
                    ) : (
                        <span></span> // reserva espacio para mantener el layout
                    )}
                    <button className='btn btn-success btn-sm' style={{ width: '30px' }} onClick={onAdd}>+</button>
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
